import React from 'react';
import * as actionCreators from '../../store/actions/login';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Formik, Form, FastField } from 'formik';
import { ErrorMessage, Label } from '../FormikCustom';
import Select from 'react-select';
import Spinner from '../Spinner/Spinner';
import { Button } from 'react-bootstrap';
import Dialog from '../Dialogs/Dialog';
import config from '../../config';
import AddPaymentInfo from './AddPaymentInfo';
import { NumericFormat } from 'react-number-format';
import classNames from 'classnames';

import fecha from 'fecha';
import { getPaymentMethods } from '../../api/paymentMethods';
import { api } from '../../api/client';
import { getBackendErrorMessage } from '../../utils/errorMessages';
import { isMethodAlreadyDefaultError, shouldSendSetAsDefaultPut } from './setAsDefaultHelpers';
class PaymentSettingsDialog extends React.Component {
    constructor(props) {
        super(props);
        let me = this;
        me.formRefs = React.createRef();
        me.state = {
            serverError: '',
            success: false,
            showDialog: false,
            showDialogAddPayment: false,
            isDirty: false,

            paymentDetails: { PaymentMethodId: 0 },
            paymentMethodsFullData: null,
            paymentMethods: null,
            selectedPaymentMethod: null,
            showAddNewPayment: false,
        };
        me.onSubmitHandler = me.onSubmitHandler.bind(me);
    }

    componentDidMount() {
        this.getPaymentMethods();
        this.updateTitle();
    }

    componentDidUpdate(prevProps) {
        if (this.props.accountnumber && this.props.accountnumber !== prevProps.accountnumber) {
            this.getPaymentMethods().then(() => {});
            this.updateTitle();
        }
    }
    updateTitle = () => {
        document.title = `Payment Method ${this.props.accountnumber} | ${config.AppTitle}`;
    };

    async getPaymentMethods() {
        const me = this;
        me.setState({ loading: true });
        try {
            //const accountNumber = "41649075";
            const accountNumber = me.props.accountnumber;
            if (accountNumber === '') {
                me.setState({ loading: false });
                return null;
            }
            let paymentMethodsFullData = await getPaymentMethods(accountNumber);

            if (paymentMethodsFullData === null) {
                me.setState({ showAddNewPayment: true, loading: false });
                return null;
            }

            let paymentMethods = mapPaymentMethods(paymentMethodsFullData);

            me.setState({ paymentMethodsFullData, paymentMethods, loading: false }, () => {
                let scheduledPaymentMethod = paymentMethodsFullData.find((f) => f.IsDefault === true);

                if (scheduledPaymentMethod) {
                    let selectedPaymentMethod = paymentMethods.find((f) => f.value === scheduledPaymentMethod.Id);
                    me.handlePaymentMethodsChange(selectedPaymentMethod);
                }
            });

            return { paymentMethodsFullData, paymentMethods };
        } catch (error) {
            let Message = error?.response?.data?.Message;
            let errorMessage = error.message ? error.message : 'Something went wrong';
            errorMessage = Message ? Message : errorMessage;
            me.setState({ serverError: errorMessage, loading: false });
            console.log(error);
        }

        function mapPaymentMethods(paymentMethodsFullData) {
            let paymentMethods = [];

            for (let i = 0; i < paymentMethodsFullData.length; i++) {
                let method = paymentMethodsFullData[i];
                let label = '';
                if (method.PaymentType === 1) {
                    label = method.Name + ': ' + method.CardBrand + ' ****' + method.LastFour;
                } else {
                    label = method.NameOnAch + ': ' + method.BankName + ' ****' + method.LastFour;
                }
                paymentMethods.push({ value: method.Id, label: label });
            }
            return paymentMethods;
        }
    }
    getExpirationDate(date) {
        if (date === null) return '';
        let dateParts = date.split('-');
        let month = dateParts[0];
        let year = dateParts[1].substr(2, 4);
        let expirationDate = `${month}${year}`;
        return expirationDate;
    }
    getDialog(message, flag, event) {
        const me = this;
        const dialog = flag ? (
            <Dialog
                onClose={event.bind(me)}
                title={message}
                show={flag}
                closeButton="false"
                closeButtonText="OK"
            ></Dialog>
        ) : null;
        return dialog;
    }

    handlePaymentMethodsChange = (selectedPaymentMethod) => {
        const me = this;
        const id = selectedPaymentMethod.value;
        let paymentDetails = {};
        let selectedPaymentMethodDetails = me.state.paymentMethodsFullData.find((f) => f.Id === id);

        paymentDetails.Id = selectedPaymentMethodDetails.Id;
        paymentDetails.Token = selectedPaymentMethodDetails.Token;

        paymentDetails.PaymentMethodId = selectedPaymentMethodDetails.PaymentType;
        paymentDetails.Name = selectedPaymentMethodDetails.Name;
        paymentDetails.NameOnAch = selectedPaymentMethodDetails.NameOnAch;

        paymentDetails.BankName = selectedPaymentMethodDetails.BankName;
        paymentDetails.BankRoutingNumber =
            selectedPaymentMethodDetails.BankRoutingNumber !== null
                ? '************' +
                  selectedPaymentMethodDetails.BankRoutingNumber.substr(
                      selectedPaymentMethodDetails.BankRoutingNumber.length - 4,
                      4
                  )
                : '';
        paymentDetails.BankAccountNumber = '************' + selectedPaymentMethodDetails.LastFour;

        paymentDetails.BillingZip = selectedPaymentMethodDetails.BillingZip;
        paymentDetails.CardBrand = selectedPaymentMethodDetails.CardBrand;
        paymentDetails.CardExpDate =
            selectedPaymentMethodDetails.CardExpDate !== ''
                ? me.getExpirationDate(selectedPaymentMethodDetails.CardExpDate)
                : '';
        paymentDetails.CardImage = selectedPaymentMethodDetails.CardImage;
        paymentDetails.LastFour = selectedPaymentMethodDetails.LastFour;
        paymentDetails.CreditCardNumber = '************' + selectedPaymentMethodDetails.LastFour;

        paymentDetails.PaymentType = selectedPaymentMethodDetails.PaymentType;
        paymentDetails.IsDefault = selectedPaymentMethodDetails.IsDefault;

        paymentDetails.selectedPaymentMethod = selectedPaymentMethod.label;

        me.setState(
            {
                paymentDetails,
                selectedPaymentMethod: selectedPaymentMethod,
                disableSubmitButton: paymentDetails.IsDefault,
            },
            () => {
                me.props.onMethodChange(paymentDetails);
            }
        );
    };
    handleDialog() {
        this.setState({ showDialog: false });
    }
    handleSuccessDialog() {
        this.setState({ showDialogAddPayment: false });
    }
    handleCancelClick() {
        const me = this;
        me.setState({ loading: true });
        this.getPaymentMethods().then(() => {});
        setTimeout(() => me.setState({ loading: false }), 2000);
    }

    handleTokenReceived = (tokenData) => {
        // Stashed so onAddNewPaymentChange('AdditionCompleted') can apply set-as-default
        // after the methods list refreshes and we know the new method's Id.
        this.pendingTokenContext = tokenData;
    };

    setAsDefaultPaymentMethod = async (paymentMethodFullData) => {
        const me = this;
        const accountNumber = me.props.accountnumber;
        const url = '/recurringPayments/' + accountNumber + '/paymentMethod';
        try {
            await api.put(url, paymentMethodFullData);
        } catch (error) {
            if (isMethodAlreadyDefaultError(error)) {
                // Backend no-op: the method is already the default, so this is a
                // success, not an error (LESSEEPORT-1593, same pattern as the
                // LESSEEPORT-1583 autopay no-op fix).
                me.setState({ serverError: '' });
                return;
            }
            const errorMessage =
                error?.response?.data?.Message || error?.message || 'Failed to set as default';
            me.setState({ serverError: errorMessage });
        }
    };

    handleAddPaymentClick() {
        const me = this;
        me.setState({ showAddNewPayment: true }, () => {
            me.props.onAddPaymentMethod(true, true);
        });
    }

    onAddNewPaymentChange = async (operation, addedPaymentMethod) => {
        const me = this;
        me.setState({ loading: true });
        if (operation === 'AdditionCompleted') {
            me.getPaymentMethods().then(async (methodsResult) => {
                let matchedFullData = null;
                if (addedPaymentMethod?.Token) {
                    matchedFullData = methodsResult?.paymentMethodsFullData?.find(
                        (f) => f.Token === addedPaymentMethod.Token
                    );
                    const matchedOption = matchedFullData
                        ? methodsResult?.paymentMethods?.find((m) => m.value === matchedFullData.Id)
                        : null;
                    if (matchedOption) {
                        me.handlePaymentMethodsChange(matchedOption);
                    }
                }

                // Skipped when the backend already auto-promoted the method (first/only
                // method case) — sending it anyway gets a 400 "Method Already Default"
                // (LESSEEPORT-1593).
                if (shouldSendSetAsDefaultPut(matchedFullData, me.pendingTokenContext)) {
                    await me.setAsDefaultPaymentMethod(matchedFullData);
                    await me.getPaymentMethods();
                }
                me.pendingTokenContext = null;

                me.setState(
                    {
                        showAddNewPayment: false,
                        loading: false,
                        showDialogAddPayment: true,
                    },
                    () => {
                        let allowPayButton = me.state.selectedPaymentMethod == null;
                        me.props.onAddPaymentMethod(allowPayButton, false);
                    }
                );
            });
        }
        if (operation === 'Cancel') {
            me.pendingTokenContext = null;
            me.setState({ loading: false }, () => {
                me.getPaymentMethods().then(() => {
                    let paymentMethodsFullData = me.state.paymentMethodsFullData;

                    me.setState(
                        {
                            showAddNewPayment: paymentMethodsFullData === null,
                        },
                        () => {
                            let allowPayButton = me.state.selectedPaymentMethod == null;
                            me.props.onAddPaymentMethod(allowPayButton, false);
                        }
                    );
                });
            });
        }
    };

    async onSubmitHandler(values, { setSubmitting }) {
        const me = this;
        const accountNumber = me.props.accountnumber;
        const url = '/recurringPayments/' + accountNumber + '/paymentMethod';
        let payload = me.state.paymentMethodsFullData.find((f) => f.Id === values.Id);
        me.setState({ loading: true });

        await api
            .put(url, payload)
            .then(function () {
                me.setState({ loading: false, showDialog: true, isDirty: false });
                setSubmitting(false);
                me.getPaymentMethods().then(() => {
                    let paymentMethodsFullData = me.state.paymentMethodsFullData;
                    me.setState({ showAddNewPayment: paymentMethodsFullData === null });
                });
            })
            .catch(function (error) {
                setSubmitting(false);
                if (isMethodAlreadyDefaultError(error)) {
                    // Backend no-op: the method is already the default — show the
                    // normal success confirmation instead of an error
                    // (LESSEEPORT-1593).
                    me.setState({ loading: false, showDialog: true, isDirty: false, serverError: '' });
                    me.getPaymentMethods().then(() => {
                        let paymentMethodsFullData = me.state.paymentMethodsFullData;
                        me.setState({ showAddNewPayment: paymentMethodsFullData === null });
                    });
                    return;
                }
                me.setState({ loading: false });
                const errorMessage = getBackendErrorMessage(error) || error.message || 'Something went wrong';
                me.setState({ serverError: errorMessage });
                console.log(error);
            });
    }
    render() {
        const me = this;
        const serverError =
            me.state.serverError !== '' ? (
                <div
                    className="errorMessage"
                    style={{
                        marginBottom: 10,
                    }}
                >
                    {me.state.serverError}
                </div>
            ) : null;
        const spinner = me.state.loading ? <Spinner /> : null;
        let paymentDetails = me.state.paymentDetails;
        paymentDetails.paymentAmount = this.props.paymentAmount;
        const dialogUpdate = me.getDialog('Payment Method updated successfully.', me.state.showDialog, me.handleDialog);
        const dialogNewPayment = me.getDialog(
            'New Payment Method has added successfully.',
            me.state.showDialogAddPayment,
            me.handleSuccessDialog
        );
        const lastFour = me.state.paymentDetails?.BankAccountNumber
            ? me.state.paymentDetails?.BankAccountNumber?.substring(
                  me.state.paymentDetails?.BankAccountNumber.length - 4
              )
            : '';
        const dateNow = fecha.format(new Date(), fecha.masks.shortDate);
        return (
            <div>
                <React.Fragment>
                    {me.state.showAddNewPayment ? (
                        <AddPaymentInfo
                            labelSize={4}
                            accountNumber={me.props.accountnumber}
                            onAddNewPaymentChange={me.onAddNewPaymentChange}
                            onTokenReceived={me.handleTokenReceived}
                            mode="create"
                        />
                    ) : (
                        ''
                    )}
                    {paymentDetails !== null && !me.state.showAddNewPayment ? (
                        <Formik
                            ref={me.formRefs}
                            enableReinitialize={true}
                            initialValues={paymentDetails}
                            onSubmit={me.onSubmitHandler}
                            validate={(values) => ({
                                PaymentMethodId:
                                    values.PaymentMethodId && values.PaymentMethodId !== 0
                                        ? null
                                        : 'Payment Method is required',
                            })}
                        >
                            {({ errors, setFieldTouched }) => (
                                <Form>
                                    <div className="form-group">
                                        <div className="form-group row">
                                            <div className="col-sm-4 col-lg-4 col-form-label">
                                                <Label htmlFor="PaymentMethodId">Payment Method:</Label>
                                            </div>
                                            <div className="col-sm-7 col-form-control">
                                                <Select
                                                    name="PaymentMethodId"
                                                    className={classNames({
                                                        'react-select': true,
                                                        error: errors.PaymentMethodId,
                                                    })}
                                                    options={me.state.paymentMethods}
                                                    onChange={me.handlePaymentMethodsChange.bind(me)}
                                                    onBlur={() => setFieldTouched('PaymentMethodId')}
                                                    value={me.state.selectedPaymentMethod}
                                                    
                                                />
                                                <ErrorMessage
                                                    component="div"
                                                    className="errorMessage"
                                                    name="PaymentMethodId"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <div className="col-sm-4 col-lg-4 col-form-label">
                                            <label htmlFor="edited-payment-amount">Payment amount</label>
                                        </div>
                                        <div className="col-sm-7 col-form-control">
                                            
                                            <FastField
                                                name="paymentAmount"
                                                className="form-control"
                                            >
                                                {({ field, form }) => {
                                                    return (
                                                        <NumericFormat
                                                            allowNegative={false}
                                                            className={classNames('form-control', {
                                                                error: form.errors.paymentAmount,
                                                            })}
                                                            value={field.value}
                                                            onBlur={() => {
                                                                form.setFieldTouched('paymentAmount');
                                                            }}
                                                            prefix={'$'}
                                                            thousandSeparator={true}
                                                            maxLength="16"
                                                            onValueChange={(values) => {
                                                                form.setFieldValue(
                                                                    'paymentAmount',
                                                                    values.floatValue ? values.floatValue : ''
                                                                );
                                                                this.props.onAmountChanged(values.floatValue);
                                                            }}
                                                        />
                                                    );
                                                }}
                                            </FastField>
                                            <ErrorMessage name="paymentAmount" />
                                        </div>
                                    </div>

                                    {serverError}
                                    {spinner}
                                    {dialogUpdate}
                                    {dialogNewPayment}

                                    <div className="form-group row">
                                        <div className="col-sm-4 col-lg-4"></div>
                                        <div className="col-sm-7">
                                            <div className="button-group">
                                                {!me.state.showAddNewPayment ? (
                                                    <Button
                                                        type="button"
                                                        onClick={(e) => me.handleAddPaymentClick(e)}
                                                        bsStyle="info"
                                                    >
                                                        Add new payment method
                                                    </Button>
                                                ) : (
                                                    ''
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    {/* <Debug /> */}
                                    <p>
                                        By clicking pay now, you are authorizing TimePayment to create a single-entry
                                        charge to your account ending: {lastFour} in the amount of $
                                        {me.props.paymentAmount}. This charge will be applied to your account on or
                                        after {dateNow}.
                                    </p>
                                    <p>Do you authorize Time Payment to proceed with this charge?</p>
                                </Form>
                            )}
                        </Formik>
                    ) : (
                        ''
                    )}
                </React.Fragment>
            </div>
        );
    }
}
export default connect(
    (state) => state.login,
    (dispatch) => bindActionCreators(actionCreators, dispatch)
)(PaymentSettingsDialog);
